// Site-wide settings (logo, hero, trucks, slogan) fetched from /api/settings
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ logo: null, hero_image: null, trucks: [], slogan: "FAST. RELIABLE REPAIRS & INSTALLATIONS." });
  const refresh = useCallback(() => {
    api.get("/settings").then(r => setSettings(prev => ({ ...prev, ...r.data }))).catch(()=>{});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
